import translator from '@Components/Utilities/Translator';
import Modal from '@Components/Shared/Modals/Modal';
import {useEffect} from 'react';

const GoodleMapsLocationModal = (props) => {

    const dealerLocation = {
        lat: props.GoogleAPIData?.PinLocation?.Latitude,
        lng: props.GoogleAPIData?.PinLocation?.Longitude
    };

    useEffect(() => {
        toggleMap();
    }, [])


    const generateInfoWindow = (map) => {
        let tld = props.GoogleAPIData.TopLevelDomain;
        let hl = props.GoogleAPIData.TwoDigitISOLanguageCode;
        let viewOn = props.GoogleAPIData.ViewOnGoogleMaps;
        map.addListener('click', (e) => {
            if (e.placeId) {
                e.stop();
                let geocoder = new google.maps.Geocoder;
                geocoder.geocode({ 'placeId': e.placeId }, (results, status) => {
                    if (status === 'OK') {
                        if (results[0]) {
                            let newInfowindow = new google.maps.InfoWindow({
                                content: '<div class="google-maps-info-wrapper">' +
                                    '<div class="google-maps-info-content">' +
                                    '<div class="google-maps-info-address">' +
                                    results[0].formatted_address +
                                    '</div>' +
                                    '<a href="https://www.google' + tld + '/maps/search/?api=1&hl=' + hl + '&query=' + results[0].formatted_address + '&query_place_id=' + results[0].place_id + '" target="_blank" class="view-link">' +
                                    viewOn + ' Google Maps</a>' +
                                    '</div>' +
                                    '</div>',
                                position: results[0].geometry.location
                            });
                            newInfowindow.open(map);
                        }
                    }
                });
            }
        });
    };
    const toggleMap = () => {
        if (props.GoogleAPIData && dealerLocation && dealerLocation.lat && dealerLocation.lng) {
            let map = new google.maps.Map(document.getElementById('dealer-map'), {
                zoom: 14,
                center: dealerLocation,
                disableDefaultUI: true,
                zoomControl: true,
                mapTypeControlOptions: {
                    mapTypeIds: [google.maps.MapTypeId.ROADMAP, google.maps.MapTypeId.HYBRID],
                    streetViewControl: true
                }
            });

            let marker = new google.maps.Marker({ position: dealerLocation, map: map });
            let infowindow = new google.maps.InfoWindow({
                content: '<div class="google-maps-info-wrapper">' +
                    '<div class="google-maps-info-title">' +
                    props.Name +
                    '</div>' +
                    '<div class="google-maps-info-content">' +
                    '<div class="google-maps-info-address">' +
                    (props.ShowStreetAddress ? props.Address1 + '<br />' : '') +
                    props.LocationAddress +
                    '</div>' +
                    '<a href="' + props.GoogleAPIData.GoogleMapsExternalUrl + '" target="_blank" class="view-link">' +
                    props.GoogleAPIData.ViewOnGoogleMaps + ' Google Maps</a>' +
                    '</div>' +
                    '</div>'
            });

            marker.addListener('click', function () {
                infowindow.open(map, marker);
            });
            generateInfoWindow(map);
        }
    };
    const onClose = () => {
        props.toggleModal();
    };

    return (
        <Modal containerClassName='google-maps-modal ts-modal-container' onEscapeKeyClose={onClose}>
            <Modal.Header onClose={onClose}>
                <Modal.Title>
                    {props.Name}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div id='dealer-map' />
                <div className='close-button'>
                    <button onClick={onClose}>{translator.translate('sandhills.closepage')}</button>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default GoodleMapsLocationModal;